import { categories, products } from "../data/products";

const categoryDetails = {
  "Face Wash": {
    eyebrow: "Daily cleanse",
    description: "Neem, tulsi, and gentle actives for fresh balanced skin.",
    icon: "01",
  },
  Serum: {
    eyebrow: "Targeted glow",
    description: "Kesar and modern actives for hydration and even tone.",
    icon: "02",
  },
  Moisturizer: {
    eyebrow: "Barrier care",
    description: "Haldi, chandan, and soft hydration for daily comfort.",
    icon: "03",
  },
  Sunscreen: {
    eyebrow: "Indian SPF",
    description: "Matte, lightweight protection made for everyday weather.",
    icon: "04",
  },
  "Ayurvedic Care": {
    eyebrow: "Ritual edits",
    description: "Heritage ingredients blended with clean skincare science.",
    icon: "05",
  },
};

const Categories = ({ activeCategory, onSelectCategory }) => {
  return (
    <section className="categories-section" id="shop">
      <div className="section-container">
        <div className="section-heading center">
          <p>Curated rituals</p>
          <h2>Shop by Skin Need</h2>
          <span>
            Premium Indian skincare collections arranged for quick discovery and everyday routines.
          </span>
        </div>

        <div className="category-grid">
          {categories.map((item) => {
            const details = categoryDetails[item];
            const productCount = products.filter((product) => product.category === item).length;

            return (
              <button
                key={item}
                className={`category-card ${activeCategory === item ? "active" : ""}`}
                type="button"
                onClick={() => onSelectCategory(item)}
              >
                <span className="category-number">{details.icon}</span>
                <span className="category-eyebrow">{details.eyebrow}</span>
                <strong>{item}</strong>
                <small>{details.description}</small>
                <span className="category-count">
                  {productCount > 0 ? `${productCount} product${productCount > 1 ? "s" : ""}` : "Explore ritual"}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Categories;
